module.exports = __webpack_public_path__ + "../resources/img/ic_add_text_default.c7021c99.svg";